export const CLEAR_RESULTS = 'CLEAR_RESULTS'
export const GLOBAL_SEARCH = 'GLOBAL_SEARCH'
export const GLOBAL_SEARCH_FAILED = 'GLOBAL_SEARCH_FAILED'
export const GLOBAL_SEARCH_SUCCEEDED = 'GLOBAL_SEARCH_SUCCEEDED'
